<template>
  <div class="content">
    <div class="header d-flex justify-content-between align-items-center">
      <div class="title ml-3">
        <h3 class="h3 mb-n2 bold">Macro Etapas</h3>
        <span class="h6 mt-n2 text-gray-400">
          Templates de macro etapas reutilizáveis nos projetos
        </span>
      </div>
      <div class="actions d-flex align-items-center">
        <button
          class="btn btn-secondary text-white elevation-3"
          @click="openNewForm"
        >
          <v-icon left class="text-white">mdi-plus</v-icon>
          Nova Macro Etapa
        </button>
      </div>
    </div>
    <div class="body">
      <div class="teros-elevation rounded">
        <v-data-table
          :headers="headers"
          :items="macroEtapas"
          :loading="loading"
          sort-by="nome"
          class="mb-7 mt-2"
          :footer-props="{
            'items-per-page-options': [-1],
          }"
          hide-default-footer
          @click:row="openEditForm"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon small @click.stop="openEditForm(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="error" @click.stop="confirmDelete(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <div class="text-center py-4">
              <p class="text-muted">Nenhuma macro etapa cadastrada.</p>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <g-modal
      :key="modalKey"
      :title="isNew ? 'Nova Macro Etapa' : 'Editar Macro Etapa'"
      :opened.sync="modalOpened"
      @close="closeForm"
      width="600"
    >
      <div class="pa-4">
        <input-v
          v-model="form.nome"
          :label="{ name: 'Nome da Macro Etapa', type: $fieldTypes.TEXT, rules: [{ rule: 'required' }] }"
        />
      </div>
      <template v-slot:buttons="{}">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="closeForm">Cancelar</v-btn>
        <v-btn color="primary" @click="saveForm" :loading="saving">Salvar</v-btn>
      </template>
    </g-modal>
  </div>
</template>

<script>
import MacroEtapaGlobalService from "@/services/macro-etapa-global.service";
import { mapGetters } from "vuex";

export default {
  components: {
    "g-modal": () => import("@/components/g-modal.vue"),
    "input-v": () => import("@/components/input-v.vue"),
  },
  data() {
    return {
      loading: false,
      saving: false,
      macroEtapas: [],
      modalOpened: false,
      modalKey: 0,
      isNew: true,
      form: {
        id: null,
        nome: "",
      },
      headers: [
        { text: "Nome", value: "nome", sortable: true },
        { text: "Ações", value: "actions", sortable: false, width: 120 },
      ],
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
  },
  methods: {
    async loadData() {
      if (!this.clientId) return;
      this.loading = true;
      try {
        const response = await MacroEtapaGlobalService.getByEmpresa(this.clientId);
        this.macroEtapas = response.data;
      } catch (error) {
        this.$notify({
          group: "geral",
          type: "error",
          title: "Erro",
          text: "Erro ao carregar macro-etapas globais",
        });
      } finally {
        this.loading = false;
      }
    },
    openNewForm() {
      this.modalKey++;
      this.isNew = true;
      this.form = { id: null, nome: "" };
      this.modalOpened = true;
    },
    openEditForm(item) {
      this.modalKey++;
      this.isNew = false;
      this.form = { ...item };
      this.modalOpened = true;
    },
    closeForm() {
      this.modalOpened = false;
      this.form = { id: null, nome: "" };
    },
    async saveForm() {
      if (!this.form.nome) {
        this.$notify({
          group: "geral",
          type: "warning",
          title: "Atenção",
          text: "Preencha o nome da macro-etapa",
        });
        return;
      }

      this.saving = true;
      try {
        if (this.isNew) {
          await MacroEtapaGlobalService.create(this.clientId, this.form);
          this.$notify({
            group: "geral",
            type: "success",
            title: "Sucesso",
            text: "Macro-etapa criada com sucesso",
          });
        } else {
          await MacroEtapaGlobalService.update(this.clientId, this.form.id, this.form);
          this.$notify({
            group: "geral",
            type: "success",
            title: "Sucesso",
            text: "Macro-etapa atualizada com sucesso",
          });
        }
        this.closeForm();
        this.loadData();
      } catch (error) {
        this.$notify({
          group: "geral",
          type: "error",
          title: "Erro",
          text: "Erro ao salvar macro-etapa",
        });
      } finally {
        this.saving = false;
      }
    },
    confirmDelete(item) {
      this.showConfirm(
        "Excluir Macro-Etapa",
        `Deseja realmente excluir "${item.nome}"?`,
        async () => {
          try {
            await MacroEtapaGlobalService.delete(this.clientId, item.id);
            this.$notify({
              group: "geral",
              type: "success",
              title: "Sucesso",
              text: "Macro-etapa excluída com sucesso",
            });
            this.loadData();
          } catch (error) {
            this.$notify({
              group: "geral",
              type: "error",
              title: "Erro",
              text: "Erro ao excluir macro-etapa",
            });
          }
        }
      );
    },
  },
  watch: {
    clientId: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
</style>
